const ecconfig = {
      //default meta config
      defaultMetas: {
        title : "亿企云|EachCloud",
        keywords : ["Salesforce","云计算服务", "企业云服务", "云计算解决方案", "EachCloud", "亿企云", "云计算咨询", "云计算安全"],
        description : "亿企云科技提供高质量的云计算服务和解决方案。我们的服务包括企业云服务、云计算咨询和云计算安全等。联系我们了解更多信息。"
      }


}
export default ecconfig



//////////////////
// WEBPACK FOOTER
// ./static/res/config.js
// module id = null
// module chunks = 